// WP-07 — provider composition: React Query (server state) around the router.
// Zustand stores need no provider (LLD-05 §2.4).
import { QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { createQueryClient } from "./query-client";
import { buildRoutes } from "./router";

export function App() {
  const [queryClient] = useState(createQueryClient);
  const [router] = useState(() => createBrowserRouter(buildRoutes()));
  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  );
}
